import { post } from './http'

//获取总体预约信息
export function getAllAppointmentInfo() {
    return post('/tyapi/pc/venueOrderCockpit/getAllAppointmentInfo', {})
}
//获取各场馆预约数据
export function getEachVenueAppointment() {
    return post('/tyapi/pc/venueOrderCockpit/getEachVenueAppointment', {})
}

//获取各场馆容量 count:总容量，count_sy:剩余容量
export function getEachVenueCapacity() {
    return post('/tyapi/pc/venueOrderCockpit/getEachVenueCapacity', {})
}

//获取场馆预约人员类型
export function getPersonnelAppointmentType() {
    return post('/tyapi/pc/venueOrderCockpit/getPersonnelAppointmentType', {})
}


//获取场馆预约热度
export function getAppointmentPopularity() {
    return post('/tyapi/pc/venueOrderCockpit/getAppointmentPopularity', {})
}

//获取实时入场信息
export function getEntrance() {
    return post('/tyapi/pc/venueOrderCockpit/getEntrance', {})
}

//获取场地列表
export function getAreas(venueId) {
    return post('/tyapi/pc/venueOrderCockpit/getAreas', {
        "venueId":venueId
    })
}

//获取场馆预约详情
export function getVenueOrderOpen(areaId,date) {
    return post('/tyapi/pc/venueOrderCockpit/getVenueOrderOpen', {
        "areaId":areaId,
        "date":date
    })
}


//获取场馆介绍
export function getVenueProfile(venueId) {
    return post('/tyapi/pc/venueOrderCockpit/getVenueProfile', {
        "venueId":venueId
    })
}

//获取场馆预约信息
export function getAppointmentInfoByVenueId(venueId) {
    return post('/tyapi/pc/venueOrderCockpit/getAppointmentInfoByVenueId', {
        "venueId":venueId
    })
}

//获取场馆当天人流量
export function getTodayVenuePedestrianFlow(venueId) {
    return post('/tyapi/pc/venueOrderCockpit/getTodayVenuePedestrianFlow', {
        "venueId":venueId
    })
}

//获取场馆项目流量
export function getVenueProjectTraffic(venueId) {
    return post('/tyapi/pc/venueOrderCockpit/getVenueProjectTraffic', {
        "venueId":venueId
    })
}

//根据场馆获取预约人员类型
export function getVenueAppointmentType(venueId) {
    return post('/tyapi/pc/venueOrderCockpit/getVenueAppointmentType', {
        "venueId":venueId
    })
}

//根据场馆获取预约热度
export function getAppointmentPopularityByVenueId(venueId) {
    return post('/tyapi/pc/venueOrderCockpit/getAppointmentPopularityByVenueId', {
        "venueId":venueId
    })
}

//获取场馆实时入场信息
export function getEntranceByVenueId(venueId) {
    return post('/tyapi/pc/venueOrderCockpit/getEntranceByVenueId', {
        "venueId":venueId
    })
}

//获取天气信息
export function getWeather() {
    return post('/tyapi/pc/venueOrderCockpit/getWeather', {
    })
}




